import React, { useEffect, useRef, useState } from "react";
import { Edit, Delete, Add } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import styles from './TeacherManagement.module.css';
import NotificationAlert from 'react-notification-alert';

// import SecurityIcon from '@mui/icons-material/Security';
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Table,
    Row,
    Col,
    Modal,
    ModalBody,
    Input,
    UncontrolledDropdown,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import TeachSignUp from "./TeachSignUp";
import { db } from "MY_LOGIN_AND_SIGNUP/db/config";
import EditTeacher from "./EditTeacher";
import firebase from "firebase";

const TeacherManagement = () => {
    const functions = firebase.functions()
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const [teacherCurrentEditId, setTeacherCurrentEditId] = useState('');

    const [userData, setUserData] = useState([]);

    const notifi = useRef();
    const notify = (msg, err) => {
        // console.log('notify')
        let color = err == false ? 'success' : 'danger';
        let options = {
            type: color,
            place: 'tr',
            message: (
                <div>
                    <div>
                        <b>{err == false ? 'Success' : 'Error'}</b> - {msg}.
                    </div>
                </div>
            ),
            icon: 'tim-icons icon-bell-55',
            autoDismiss: 6,
        };
        if (notifi.current) {
            notifi.current.notificationAlert(options);
        }
        // notification(options);
    };

    useEffect(() => {
        getUsers();
    }, []);

    const filterUsers = (users, searchString) => {
        if (!searchString) return users; // If no search string, return all users

        const lowerCaseSearch = searchString.toLowerCase();

        return users.filter(user =>
            user.username.toLowerCase().includes(lowerCaseSearch) ||
            user.email.toLowerCase().includes(lowerCaseSearch) ||
            user.mobile.includes(searchString) ||
            (user.batch && user.batch.some(b => b.label.toLowerCase().includes(lowerCaseSearch)))
        );
    };

    const getUsers = async (searchString) => {
        document.querySelector('#loading-indicator').style.display = 'flex';

        try {
            console.log('checkind 1', searchString);

            const userSnapshot = await db.collection('zSystemUsers')
                .where('isTeacher', '==', true)
                .where('status', '==', 0)
                .get();

            console.log('checkind 2', userSnapshot.docs.length); // Debugging: Check how many docs are fetched

            let users = userSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            console.log('checkind 2', users);

            const batchSnapshot = await db.collection('Batch')
                .where('type', '==', 'batch')
                .get();
            console.log('checkind 3');

            let batchList = batchSnapshot.docs.map(doc => ({
                label: doc.data().batchName,
                value: doc.data().itemID
            }));
            console.log('batchList', batchList);

            // Map batch IDs in isBatchManage to batch details
            users = users.map(user => ({
                ...user,
                batch: Array.isArray(user.isBatchManage)
                    ? user.isBatchManage.map(batchId => batchList.find(batch => batch.value === batchId) || null).filter(Boolean)
                    : []
            }));
            console.log(users, 'checing User final');
            if(searchQuery.trim()!=''){
                const filteredUsers = filterUsers(users, searchString);
                return setUserData(filteredUsers)
            }
            setUserData(users);
        } catch (err) {
            notify(err, true);
        } finally {
            document.querySelector('#loading-indicator').style.display = 'none';
        }
    };

    const editTeacherHandler = (teacherId) => {
        try {
            setTeacherCurrentEditId(teacherId);
            console.log('isEditModal', teacherId);
            setIsEditModalVisible(true)
           
        } catch (error) {
            console.log(error);
        }
    }

    const deleteTeacherHandler = async (teacherId) => {
        const deleteTeacher = functions.httpsCallable('deleteTeacherAccount');
        try {
            const result = await deleteTeacher({ teacherId });
            console.log(result.data.message);
            notify('Teacher deleted successfully', false);
            getUsers();
        } catch (error) {
            console.error('Error deleting teacher:', error.message);
            notify('Failed to delete teacher', true);
        }
    };

    const searchHandler=(e)=>{
        try {
            const search = e?.target?.value;
            setSearchQuery(search);
            if(search?.trim()=='') return getUsers();
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <>
            <div className='content'>
                <div className='react-notification-alert-container'>
                    <NotificationAlert ref={notifi} />
                </div>
                <Modal
                    isOpen={isModalVisible}
                    style={{ display: 'flex', flex: 1, top: -100 }}
                    size='lg'
                >
                    <ModalBody className={styles.create__user_modal_body} size='sm'>
                        <TeachSignUp
                            setUserData={setUserData}
                            notify={notify}
                            getUsers={getUsers}
                            onClick={() => {
                                setIsModalVisible(false);
                            }}
                        ></TeachSignUp>
                    </ModalBody>
                </Modal>

                <Modal
                    isOpen={isEditModalVisible}
                    style={{ display: 'flex', flex: 1, top: -100 }}
                    size='lg'
                >
                    <ModalBody className={styles.create__user_modal_body} size='sm'>
                        <EditTeacher
                            setUserData={setUserData}
                            teacherId={teacherCurrentEditId}
                            getUsers={getUsers}
                            notify={notify}
                            onClick={() => {
                                setIsEditModalVisible(false);
                            }}
                        ></EditTeacher>
                    </ModalBody>
                </Modal>


                <Row>
                    <Col md='12'>
                        <Card>
                            <CardHeader>
                                <Row>
                                    <Col sm={9} style={{ textAlign: 'center' }}>
                                        <CardTitle tag='h4' style={{ fontWeight: 300 }}>
                                            TEACHER MANAGEMENT
                                        </CardTitle>
                                    </Col>
                                    <Col sm={3}>
                                        <Button color='info' onClick={() => { setIsModalVisible(true) }}>
                                            Create Teacher <Add />
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={4}>
                                        <Input
                                            type='text'
                                            name='searchInvoice'
                                            placeholder='Search Teacher'
                                            onChange={searchHandler}
                                        />
                                    </Col>
                                    <Col style={{ paddingLeft: '0px' }} sm={2}>
                                        <Button
                                            style={{ margin: '0px', padding: '6px 10px' }}
                                            color='info'
                                            onClick={() => { getUsers(searchQuery) }}
                                        >
                                            <SearchIcon />
                                        </Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                {userData?.length > 0 ?
                                    <Table className='tablesorter'>
                                        <thead className='text-primary'>
                                            <tr>
                                                <th>User Name</th>
                                                <th style={{ textAlign: 'center' }}>Email</th>
                                                <th style={{ textAlign: 'center' }}>Mobile</th>
                                                <th style={{ textAlign: 'center' }}>View Batch</th>
                                                <th style={{ textAlign: 'center' }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {userData.map((user,i) => (
                                                <tr key={user.id || user.email}>
                                                    <td>{user.username}</td>
                                                    <td style={{ textAlign: 'center' }}>{user.email}</td>
                                                    <td style={{ textAlign: 'center' }}>{user.mobile}</td>
                                                    <td style={{ textAlign: 'center', position: 'relative' }}>
                                                        <UncontrolledDropdown style={{ display: 'flex', justifyContent: 'center' }} direction={userData.length - i < 3 ? "up" : "down"}>
                                                            <DropdownToggle
                                                                style={{ margin: '0px', padding: '6px 10px' }}
                                                                className='nav-link'
                                                                color='info'
                                                                caret={userData.length - i >= 3} // Hide caret when down
                                                            >
                                                                View
                                                            </DropdownToggle>
                                                            <DropdownMenu style={{ transform: 'translateX(-50%)', left: '50%' }}>
                                                                <DropdownItem header style={{ color: 'black', fontSize: '0.8rem' }}>
                                                                    Assigned Batch
                                                                </DropdownItem>
                                                                {user?.batch?.length ? (
                                                                    user.batch.map((batch) => (
                                                                        <DropdownItem key={batch.label} style={{ color: 'black' }}>
                                                                            {batch.label || 'No Batch Assigned'}
                                                                        </DropdownItem>
                                                                    ))
                                                                ) : (
                                                                    <DropdownItem style={{ color: 'black' }}>
                                                                        No Batch Assigned
                                                                    </DropdownItem>
                                                                )}
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                    </td>

                                                    <td style={{ cursor: 'pointer', textAlign: 'center' }}>
                                                        <Edit style={{ color: '#247cf7' }} onClick={() => {
                                                            editTeacherHandler(user.id);
                                                        }} />
                                                        <Delete style={{ color: 'red' }} onClick={() => {
                                                            deleteTeacherHandler(user.id);
                                                        }} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table> : <div
                                        style={{
                                            textAlign: 'center',
                                            fontSize: '18px',
                                            fontWeight: 'bold',
                                            padding: '20px',
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            marginTop: '20px',
                                        }}
                                    >
                                        {searchQuery
                                            ? 'No Teacher Availabe For This Search'
                                            : ' No Teacher Available'}
                                    </div>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default TeacherManagement;